  <template>
    <div class="ewm-footer" :class="$common.qr.type!=TYPE_SOLUTION?'footer-space':''">
        <Button :label="$t('message.powered_by_88E')" class="p-button-text" v-if="$common.version==$common.E88&&$common.trademark"/>
        <Button :label="$t('message.powered_by_top_qr')" class="p-button-text" v-if="$common.version!=$common.E88&&$common.trademark"/>
    </div>
  </template>
  
  <script>
    import Button from 'primevue/button';

    export default {
      name: 'EwmFooter',
      components: {
        Button
      },      
      data(){
        return {
          TYPE_SOLUTION:'0'
        }
      },
      props: {
          footer:null
      },
      created(){


      },
      mounted(){

        

      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style>
   
   .ewm-footer{
      text-align: center;
      font-size:small;
      margin-top: 2rem;
      padding:1rem 0;
   }

  .footer-space{
      flex-grow: 1;
      flex-shrink: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
  }
 
  </style>